import Typography from "@mui/material/Typography";
import NavBar from "./NavBar";
import { Badge, Box, Chip, Collapse, Container, Divider, Drawer, Grid, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Stack, Toolbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckListIcon from '@mui/icons-material/Checklist';
import {ExpandLess,ExpandMore} from '@mui/icons-material';
import { useState } from "react";
import { FinancialClearanceMenu } from "./NavMenuItems/FinancialClearanceMenu";
import { ConfigurationMenu } from "./NavMenuItems/ConfigurationMenu";
import { SchedulingMenu } from "./NavMenuItems/SchedulingMenu";
import { MedicalRecordsMenu } from "./NavMenuItems/MedicalRecordsMenu";
import { CaseManagementMenu } from "./NavMenuItems/CaseManagementMenu";
import { RefundMenu } from "./NavMenuItems/RefundMenu";
import { ContractMenu } from "./NavMenuItems/ContractMenu";
import { WriteoffMenu } from "./NavMenuItems/WriteoffMenu";
import { AppealsMenu } from "./NavMenuItems/AppealsMenu";
import { LaborMenu } from "./NavMenuItems/LaborMenu";
import { MedNecMenu } from "./NavMenuItems/MedNecMenu";
import { AgentsMenu } from "./NavMenuItems/AgentsMenu";
import { ClaimsMenu } from "./NavMenuItems/ClaimsMenu";
import { RevenueRecognitionMenu } from "./NavMenuItems/RevenueRecognitionMenu";
import { DenialsMenu } from "./NavMenuItems/DenialsMenu";

type Props = {
    children?: React.ReactNode;
};

export const PageLayout: React.FC<Props> = ({ children }) => {
    return (
        <>
            <NavBar />
            <Box sx={{ display: "flex", height: "100vh" }}>
                {/* Sidebar Drawer */}
                <Box>
                    <Drawer
                        variant="permanent"
                        anchor="left"
                        open
                        sx={{
                            width: 240,
                            flexShrink: 0,
                            [`& .MuiDrawer-paper`]: { width: 240 },
                            boxSizing: "border-box",
                        }}
                    >
                        <Toolbar />
                        <Divider />
                        <ConfigurationMenu />
                        <SchedulingMenu />
                        <MedicalRecordsMenu />
                        <FinancialClearanceMenu />
                        <CaseManagementMenu />
                        <RefundMenu />
                        <ContractMenu />
                        <WriteoffMenu />
                        <AppealsMenu />
                        <LaborMenu />
                        <MedNecMenu />
                        <RevenueRecognitionMenu />
                        <ClaimsMenu />
                        <DenialsMenu />
                        <AgentsMenu />
                    </Drawer>
                </Box>

                {/* Main Content */}
                <Box sx={{ flex: 1, minWidth: 0, marginTop: "75px", marginLeft: "24px", padding: "8px", overflowX: "auto" }}>
                    {children}
                </Box>
            </Box>
        </>
    );
};